import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/models';
import * as _ from "lodash";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public isLoggedInSubject: BehaviorSubject<any>;
  public currentUser: Observable<User>;
  public isLoggedIn: Observable<any>;

  constructor(private http: HttpClient) {
    let _currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserSubject = new BehaviorSubject<User>(_currentUser);
    let loggedIn = false;
    if (_currentUser && _currentUser.is_logged_in) {
      loggedIn = true;
    }
    this.isLoggedInSubject = new BehaviorSubject<any>(loggedIn);
    this.currentUser = this.currentUserSubject.asObservable();
    this.isLoggedIn = this.isLoggedInSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get isLoggedInUser(): User {
    return this.isLoggedInSubject.value;
  }

  login(username: string, password: string) {
    let data = {
      "grant_type": "password",
      "client_id": "2",
      "client_secret": environment.portal_client_secret,
      "username": username,
      "password": password
    }
    return this.http.post<any>(`${environment.portal_url}/oauth/token`, data)
      .pipe(map(user => {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        this.isLoggedInSubject.next(true);
        return user;
      }));
  }

  accessScs() {
    let data = {
      client_id: environment.scs_client_id,
      client_secret: environment.scs_client_secret,
      grant_type: environment.scs_grant_type,
      password: environment.scs_password,
      username: environment.scs_username
    }
    return this.http.post<any>(`${environment.scs_url}/oauth/access_token`, data)
        .pipe(map(user => {
            let token = user.access_token;
            user.scs_access_token = token;
            delete user.access_token;
            this.updateUser(user, true);
            return user;
        }));
  }

  updateUser(new_user, withOutSubject = false) {
    var promise = new Promise((resolve, reject) => {
      let cuUser = JSON.parse(localStorage.getItem('currentUser'));
      let mergedUser = _.merge(cuUser, new_user);
      localStorage.setItem('currentUser', JSON.stringify(mergedUser));
      if (!withOutSubject) {
        if (new_user.is_logged_in) {
          this.isLoggedInSubject.next(new_user.is_logged_in);
        }
        this.currentUserSubject.next(mergedUser);
      }
      setTimeout(() => {
        resolve(true);
      }, 0);
    });
    return promise;
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('styles');
    this.currentUserSubject.next(null);
    this.isLoggedInSubject.next(false);
  }
}
